import { Slide, Zoom } from "react-reveal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { settings } from "../reusables/carousel";
import TestimonialCard from "../reusables/TestimonialCard";

const HomeTestimonials = () => {
  return (
    <section className="home-testimonials section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container section-spacing-100 no-padding-top">
            <div className="section-head flex section-spacing-50 no-padding-top">
              <div className="section-head-titles">
                <p className="section-tag boldTitle">TESTIMONIALS</p>
                <Slide top>
                  <h2 className="section-title ntuna-text-fill">
                    What They're Saying About NTUNA.COM<sup>&trade;</sup>
                  </h2>
                </Slide>
                <p className="section-subtitle font-inter-regular">
                  Hear directly from organizations that have trusted NTUNA.COM
                  with their web and ICT challenges.
                </p>
              </div>
              <div className="section-head-rates flex">
                <Slide top>
                  <div className="section-head-rate-item google">
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1777959271/ntuna/google_th0rxv.svg"
                        alt="Ntuna.com's Google Reviews"
                      />{" "}
                      <div>
                        <div className="flex google-review">
                          <span className="boldTitle rate-average ntuna-dark">
                            4.9
                          </span>
                          <div className="rate-stars-container">
                            <img
                              src="https://res.cloudinary.com/malidad/image/upload/v1777961231/4star_uflegw.svg"
                              alt="4.9 Star"
                              className="rate-star"
                            />
                          </div>
                        </div>
                        <span className="uppercase rate-label">
                          customer reviews
                        </span>
                      </div>
                    </a>
                  </div>
                </Slide>
                <Slide top>
                  <div className="section-head-rate-item sortlist">
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1777959281/ntuna/sortlist_bwhb6x.svg"
                        alt="Sortlist best in class"
                      />
                    </a>
                  </div>
                </Slide>
              </div>
            </div>
            <div className="section-body">
              <div className="testimonials-trust-container flex">
                <div className="testimonials-container slider-items-container">
                  <Slider {...settings}>
                    <TestimonialCard
                      testimonial="Working with NTUNA.COM was an outstanding experience. Their team handled our logo design, social media setup, company profile, and website development with exceptional professionalism. They understood our vision and delivered a strong, modern brand presence."
                      logo="https://res.cloudinary.com/malidad/image/upload/v1777959338/ntuna/abcd_hbpyp0.jpg"
                      name="Tahan Sheith"
                      profile="Operations Manager, The ABCD Company"
                    />
                    <TestimonialCard
                      testimonial="As we were entering the Ugandan market, we needed to present ourselves professionally from the start. NTUNA helped us set up a solid digital foundation with our website, business emails, and Google Business profile. Everything was handled in a structured and reliable way, and the final result gave us the confidence to engage clients in a new market."
                      logo="https://res.cloudinary.com/malidad/image/upload/v1777959343/ntuna/negash_fztjki.png"
                      name="Mr. Negash"
                      profile="Director, Negash Construction Company"
                    />
                    <TestimonialCard
                      testimonial="We had a very tight timeline—we needed a website ready in just 3 days for our visitation day. NTUNA understood the urgency and delivered exactly on time without compromising quality. The website represented our school well, and the process was smooth. We continue to rely on them for management and support."
                      logo="https://res.cloudinary.com/malidad/image/upload/v1777959343/ntuna/kcg_xfj6d7.png"
                      name="Mr. Ssenabulya Francis"
                      profile="Head Teacher, Kampala City Grammar School"
                    />
                    <TestimonialCard
                      testimonial="We needed to strengthen our credibility, especially when engaging with funders and partners. NTUNA helped us build a professional website and align our social media presence in a way that clearly communicates who we are and what we do. The difference in how we are perceived now is significant."
                      logo="https://res.cloudinary.com/malidad/image/upload/v1777959344/ntuna/sda_zhkaim.jpg"
                      name="Mr. Johnson"
                      profile="Director, Single Dollar Appeal"
                    />
                  </Slider>
                </div>
                <div className="trust-container">
                  <Zoom>
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959338/ntuna/arasus_sd6jtz.jpg"
                      alt="Arasus Aviation"
                    />
                  </Zoom>
                  <Zoom delay={100}>
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959339/ntuna/bluetides_xdxbfi.png"
                      alt="Bluetides Uganda Limited"
                    />
                  </Zoom>
                  <Zoom delay={200}>
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959343/ntuna/kambo_xciszx.png"
                      alt="Kambo Autos"
                    />
                  </Zoom>
                  <Zoom delay={300}>
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959342/ntuna/dylan_lofhad.png"
                      alt="Dylan Medical Services"
                    />
                  </Zoom>
                  <Zoom delay={400}>
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959338/ntuna/abcd_hbpyp0.jpg"
                      alt="The ABCD Company"
                    />
                  </Zoom>
                  <Zoom delay={500}>
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959342/ntuna/habibk9_rahqoo.png"
                      alt="Great Habib K9 Academy"
                    />
                  </Zoom>
                  <Zoom delay={600}>
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959342/ntuna/jmstone_dssnxz.png"
                      alt="Jmstone Logistics"
                    />
                  </Zoom>
                  <Zoom delay="700">
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959341/ntuna/charitywater_ajssje.jpg"
                      alt="Charity Water Organization"
                    />
                  </Zoom>
                  <Zoom delay={800}>
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959343/ntuna/kcg_xfj6d7.png"
                      alt="Kampala City Grammar School"
                    />
                  </Zoom>
                  <Zoom delay={900}>
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959342/ntuna/habibfarm_orkoef.png"
                      alt="Great Habib Smart Farm Academy"
                    />
                  </Zoom>
                  <Zoom delay={1000}>
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959346/ntuna/ui_cyodqh.jpg"
                      alt="Upcountry Investors"
                    />
                  </Zoom>
                  <Zoom delay={1100}>
                    <img
                      src="https://res.cloudinary.com/malidad/image/upload/v1777959339/ntuna/aypoultryfarm_cml3ue.jpg"
                      alt="AY Poultry Farm"
                    />
                  </Zoom>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeTestimonials;
